/* eslint-disable no-unused-vars */
import classNames from 'classnames';
import PropType from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { getStyle } from '../../../features/analyses/Freeform/FreeformAnalysisLayout/AddReportDataLayoutContainer/EditLayout/LeftPanel/Section/SectionArea/utils';
import './SectionArea.scss';

import ObjectInjestPopover from './ObjectInjestPopover';
import DraggableLibraryItemCard from './DraggableLibraryItemCard';
import DeleteButton from './DeleteButton/DeleteButton';
import { EmptyClipboardModal } from '../EmptyClipboardModal';
import { PowerBiContainer } from '../SelectReport/PowerBiContainer';
import { TableauContainer } from '../SelectReport/TableauContainer';

function SectionArea({
  areaClass,
  panel,
  topic,
  panelNumber,
  onRichTextContentUpdate,
  showRightPanel,
  onInsertExcelOrPPT = () => {},
  onAddPBIItem = () => {},
  onAddTableauItem = () => {},
  onAddTextContent,
  onRemoveContent,
  showEmptyClipboardModal = false,
  onEmptyModalHide = () => null,
  isPowerBiEnabled = true,
  projectId,
  droppableLocationId,
  excelPPTItem,
  objectInjestPopoverAddButtonTitle,
  onFormatTypeChange = () => {},
  dynamicExcelObject,
  panels,
}) {
  const [mouseOver, setMouseOver] = useState(false);
  const hideClearSectionButton = () => {
    setMouseOver(false);
  };
  const [clearSectionHover, setClearSectionHover] = useState(false);
  const [showPowerBIModal, setPowerBIModalDisplay] = useState(false);
  const [showTableauModal, setShowTableauModal] = useState(false);

  const handleOnDelete = () => {
    onRemoveContent(panelNumber);
  };

  const handleInsertExcelOrPPT = () => {
    onInsertExcelOrPPT(panelNumber);
  };

  const handleInsertText = () => {
    onAddTextContent(panelNumber);
  };

  const isAllowedToDisplayClearButton = () => {
    return mouseOver && panel.type && !showRightPanel;
  };

  return (
    <Droppable
      droppableId={droppableLocationId}
      direction="vertical"
      key={droppableLocationId}
      ignoreContainerClipping
    >
      {(provided, snapshot) => {
        const computedStyle = getStyle(
          snapshot,
          droppableLocationId,
          false,
          {},
          []
        );
        const key = panel.libraryItemId || panel.panelNumber;
        // const computedHint = getHint(snapshot);

        return (
          <div
            className={`${areaClass} section-area__droppable-container`}
            data-testid={areaClass}
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={computedStyle}
            onMouseEnter={() => setMouseOver(true)}
            onFocus={() => setMouseOver(true)}
            onMouseLeave={hideClearSectionButton}
            onBlur={hideClearSectionButton}
          >
            {!panel.type ? (
              <div className={classNames('section-area__background')}>
                <div className="section-area__background__content">
                  <ObjectInjestPopover
                    onInsertExcelOrPPT={handleInsertExcelOrPPT}
                    onInsertPowerBi={() => {
                      // TODO: jm - use common modal for powerbi and tableau
                      setPowerBIModalDisplay(true);
                    }}
                    onInsertTableau={() => {
                      // TODO: jm - use common modal for powerbi and tableau
                      setShowTableauModal(true);
                    }}
                    onInsertText={handleInsertText}
                    onPopover={() => {}}
                    allowTextOnly={false}
                    isPowerBiEnabled={isPowerBiEnabled}
                    buttonTitle={objectInjestPopoverAddButtonTitle}
                  />
                  {showPowerBIModal && (
                    <PowerBiContainer
                      show={showPowerBIModal}
                      onAdd={(PBIItem) => {
                        setPowerBIModalDisplay(false);
                        onAddPBIItem(PBIItem, panelNumber);
                      }}
                      onHide={() => setPowerBIModalDisplay(false)}
                    />
                  )}
                  {showTableauModal && (
                    <TableauContainer
                      show={showTableauModal}
                      onAdd={(tableauItem) => {
                        setShowTableauModal(false);
                        onAddTableauItem(tableauItem, panelNumber);
                      }}
                      onHide={() => setShowTableauModal(false)}
                    />
                  )}
                </div>
              </div>
            ) : (
              <>
                <div
                  className={classNames('section-area__item-container', {
                    'background-left': false,
                  })}
                >
                  <DraggableLibraryItemCard
                    key={key}
                    panelNumber={panelNumber || panel.panelNumber}
                    panel={panel}
                    topic={topic}
                    panels={panels}
                    onRichTextContentUpdate={onRichTextContentUpdate}
                    isDragDisabled
                    projectId={projectId}
                    excelPPTItem={excelPPTItem}
                    dynamicExcelObject={dynamicExcelObject}
                    onFormatTypeChange={onFormatTypeChange}
                  />
                </div>
                <div
                  className="clearSectionWrapper"
                  style={{
                    display: isAllowedToDisplayClearButton() ? 'flex' : 'none',
                  }}
                >
                  <DeleteButton
                    tooltip="Clear section"
                    tooltipPlacement="top"
                    iconType={`${
                      clearSectionHover ? 'fill' : 'outline'
                    } icon-grey-theme`}
                    handleClick={handleOnDelete}
                    handleMouseEnter={() => setClearSectionHover(true)}
                    handleMouseLeave={() => setClearSectionHover(false)}
                  />
                </div>
              </>
            )}
            {showEmptyClipboardModal && (
              <EmptyClipboardModal onHide={onEmptyModalHide} />
            )}
          </div>
        );
      }}
    </Droppable>
  );
}

SectionArea.propTypes = {
  areaClass: PropType.string,
};

SectionArea.defaultProps = {
  areaClass: '',
};

export default SectionArea;
